import validate from "/usr/src/app/content/n3-redirections-service-0ccab277-9a74-42ca-89e5-e491df251cba/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-redirections-service-0ccab277-9a74-42ca-89e5-e491df251cba/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}